import React from "react";

import VolumeOffIcon from "../../../icons/VolumeOffIcon";
import VolumeOnIcon from "../../../icons/VolumeOnIcon";
import { usePlayerStore } from "../../../store/usePlayerStore";
import IconButton from "../IconButton";

const MuteButton = ({
  fillColor,
  ...props
}: {
  "aria-label": string;
  fillColor: string;
  isMobile: boolean;
  onFocus?: () => void;
  onMouseOver?: () => void;
}) => {
  const { useStoreState } = usePlayerStore();
  const isMuted = useStoreState.isMuted();
  const player = useStoreState.player();

  return (
    <IconButton {...props} onClick={() => player.setMuted(!isMuted, true)}>
      {isMuted ? (
        <VolumeOffIcon fillColor={fillColor} />
      ) : (
        <VolumeOnIcon fillColor={fillColor} />
      )}
    </IconButton>
  );
};

export default MuteButton;
